import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import newsViewImg from "../assets/news.jpg";
import eventViewImg from "../assets/event.jpg";

const News = () => {
  const navigate = useNavigate();

  const [events, setEvents] =
    useState([]);

  const [news, setNews] =
    useState([]);

  useEffect(() => {
    fetch(
      "https://kasiaweb.ilakshyaerp.in/api/events"
    )
      .then((res) =>
        res.json()
      )
      .then((data) =>
        setEvents(
          Array.isArray(data)
            ? data
            : []
        )
      );
  }, []);

  useEffect(() => {
    fetch(
      "https://kasiaweb.ilakshyaerp.in/api/news"
    )
      .then((res) =>
        res.json()
      )
      .then((data) =>
        setNews(
          Array.isArray(data)
            ? data
            : []
        )
      );
  }, []);

  const shortText = (
    text
  ) => {
    if (!text) return "";

    const words =
      text.split(" ");

    return words
      .slice(0, 4)
      .join(" ");
  };

  return (
    <div className="edu-news-section">

      {/* HEADING */}
      <div className="edu-news-head">
        <h2>
          NEWS AND EVENTS
        </h2>

        <p>
          Find Out What's Happening In School
        </p>
      </div>

      {/* ================= NEWS ================= */}

      <div className="edu-news-row">

        {news.length === 0 ? (
          <div className="no-card-box">
            🚫 No News Available
          </div>
        ) : (
          <>
            {news
              .slice(0, 4)
              .map((item) => (
                <div
                  key={
                    item.id
                  }
                  className="edu-news-card"
                  onClick={() =>
                    navigate(
                      "/news"
                    )
                  }
                >
                  <img
                    src={`https://kasiaweb.ilakshyaerp.in/uploads/news/${item.image}`}
                    alt=""
                  />

                  <div className="edu-overlay">
                    {shortText(
                      item.title
                    )}
                  </div>
                </div>
              ))}

            {news.length > 0 && (
              <div
                className="edu-news-card view-all-card"
                onClick={() => navigate("/news")}
              >
                <img
                  src={newsViewImg}
                  alt="View All News"
                />

                <div className="edu-overlay">
                  View All News
                </div>
              </div>
            )}
          </>
        )}

      </div><br/>

      {/* ================= EVENTS ================= */}


      <div className="edu-news-row">

        {events.length ===
          0 ? (
          <div className="no-card-box">
            🚫 No Events Available
          </div>
        ) : (
          <>
            {events
              .slice(0, 4)
              .map((item) => (
                <div
                  key={
                    item.id
                  }
                  className="edu-news-card"
                  onClick={() =>
                    navigate(
                      "/events"
                    )
                  }
                >
                  <img
                    src={`https://kasiaweb.ilakshyaerp.in/uploads/events/${item.image}`}
                    alt=""
                  />

                  <div className="edu-overlay">
                    {shortText(
                      item.narration
                    )}
                  </div>
                </div>
              ))}

            {events.length > 0 && (
              <div
                className="edu-news-card view-all-card"
                onClick={() => navigate("/events")}
              >
                <img
                  src={eventViewImg}
                  alt="View All Events"
                />

                <div className="edu-overlay">
                  View All Events
                </div>
              </div>
            )}
          </>
        )}

      </div>

    </div>
  );
};

export default News;